// extracted by mini-css-extract-plugin
export default {"wrapper":"Layout_wrapper__L6hgH","title":"Layout_title__32tfe","text":"Layout_text__p4tdw","image":"Layout_image__2lVru","form":"Layout_form__qDb8P"};